import { render, staticRenderFns } from "./ContactBanner.vue?vue&type=template&id=5d355835&scoped=true&"
import script from "./ContactBanner.vue?vue&type=script&lang=js&"
export * from "./ContactBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d355835",
  null
  
)

export default component.exports